/* eslint-disable max-len */
import { qryUseractPrize } from '@tencent/wphk-act-base-cgi';
import dayjs from 'dayjs';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';

/**
 * 获取印花的优惠券及兑换活动信息
 * @param stampBatchNo 印花批次号
 */
export async function queryActPrizeInfo(actListid: string, offset?: number, limit?: number, startTime?: Date, endTime?: Date) {
  const data = await qryUseractPrize({  actListid, offset, limit, startTime, endTime });
  return data;
}

/**
 * 活动参与信息
 */
type ActJoinedInfoRes = {
  /** 是否参与 */
  isJoined: boolean,
  /** 当天是否参与 */
  isCurDayJoined: boolean,
  /** 当月是否参与 */
  isCurMonthJoined: boolean,
  /** 活动id */
  actlistId: string,
};

  /**
   * 批量活动参与信息
   */
  type BatchActJoinedInfoRes = {
    /** 是否参与 */
    isJoined: boolean,
    /** 当天是否参与 */
    isCurDayJoined: boolean,
    /** 当月是否参与 */
    isCurMonthJoined: boolean,
    /** 活动id */
    /** 当日参与的活动Id列表 */
    dayJoinedActIdList: string[],
    /** 当月参与的活动Id列表 */
    monthJoinedActIdList: string[],
    /** 参与的活动Id列表 */
    joinedActIdList: string[],
  };

/**
 * 通过活动加密Id，查询活动参与记录
 * @param actlistId 活动（加密）id
 * @param compareMonthDate 比较的月份日期
 */
// eslint-disable-next-line max-len
export async function getActJoinedInfo(actlistId: string, compareMonthDate?: Date, offset?: number, limit?: number, startTime?: Date, endTime?: Date): Promise<ActJoinedInfoRes> {
  const now = getServerTime();
  const theCompareMonth = compareMonthDate ? compareMonthDate : now;
  const res =  await queryActPrizeInfo(actlistId, offset, limit, startTime, endTime);
  const { userActPrizeList } = res;
  let isCurDayJoined = false;
  let isCurMonthJoined = false;
  let isJoined = false;

  if (userActPrizeList && userActPrizeList.length > 0) {
    isJoined = true;
    userActPrizeList.forEach((item) => {
      const { actTime } = item;

      // 判断是否当日参与
      if (dayjs(now).isSame(dayjs(actTime), 'day')) {
        isCurDayJoined = true;
      }
      // 判断是否当月参与
      if (dayjs(theCompareMonth).isSame(dayjs(actTime), 'month')) {
        isCurMonthJoined = true;
      }
    });
  }
  return {
    isJoined,
    isCurDayJoined,
    isCurMonthJoined,
    actlistId,
  };
}

/**
   * 批量查询活动参与信息
   * 获取一组活动参与的记录，是否参与，当月是否参与，当日是否参与
   * 当日参与的活动id列表， 当月参与的活动id列表
   * @param actIdList 活动id
   * @param compareMonthDate 比较的月份日期
   */
// eslint-disable-next-line max-len
export async function batchGetActJoinedInfo(actIdList: string[], compareMonthDate?: Date): Promise<BatchActJoinedInfoRes> {
  const batchGetJoinInfoPromise = actIdList.map(async  actList => await getActJoinedInfo(actList, compareMonthDate));
  const joinInfoResultList = await Promise.all(batchGetJoinInfoPromise);
  /** 是否当日参与过 */
  let isCurDayJoined = false;
  /** 是否当月参与过 */
  let isCurMonthJoined = false;
  /** 是否参与过 */
  let isJoined = false;
  /** 当日参与的活动Id列表 */
  const dayJoinedActIdList: string[] = [];
  /** 当月参与的活动Id列表 */
  const monthJoinedActIdList: string[] = [];
  /** 参与的活动Id列表 */
  const joinedActIdList: string[] = [];


  joinInfoResultList.forEach((item) => {
    const { actlistId } = item;
    isCurDayJoined = isCurDayJoined || item.isCurDayJoined;
    isCurMonthJoined = isCurMonthJoined || item.isCurMonthJoined;
    isJoined = isJoined || item.isJoined;

    if (item.isJoined) {
      joinedActIdList.push(actlistId);
    }

    if (item.isCurMonthJoined) {
      monthJoinedActIdList.push(actlistId);
    }
    if (item.isCurDayJoined) {
      dayJoinedActIdList.push(actlistId);
    }
  });

  return {
    isJoined,
    isCurDayJoined,
    isCurMonthJoined,
    joinedActIdList,
    dayJoinedActIdList,
    monthJoinedActIdList,
  };
}


